module.exports = __webpack_public_path__ + "79227d595841d20504be6a8465f4647e.pdf";